import React from "react";
import Sidebar from "../../components/Sidebar";
import MentorPricingForm from "../../components/forms/MentorPricingForm";
import WelcomeCard from "../../components/WelcomeCard";

export default function MentorPricing() {
  return (
    <Sidebar>
      <WelcomeCard title={"Pricing"} />

      <div className="bg-white p-6 mt-5 rounded-lg shadow-md">
        <MentorPricingForm />
      </div>
    </Sidebar>
  );
}
